import { Spin } from "antd";
import React, { FC } from "react";

import useHttpGet from "../../hooks/useHttpGet";
import { APIRoutes } from "../../http";
import { IAdBlock } from "../../models/ad-block.model";
import { IResultResponse } from "../../models/response/result.model";
import { MagicPagesTypes } from "../../services/enums";

const SiteSponsors: FC = () => {
  const { fetchedData, loading } = useHttpGet<IResultResponse<IAdBlock[]>>(
    `${APIRoutes.AD_BLOCKS}/${MagicPagesTypes.Home}`,
    {
      dependencies: [],
      defaultValue: { result: [] as IAdBlock[] },
    }
  );

  return (
    <div className="mb-1">
      <h3 className="mt-1">SITE SPONSORS</h3>
      <Spin spinning={loading}>
        {fetchedData.result.map((el: IAdBlock) => (
          <div
            key={el.id}
            dangerouslySetInnerHTML={{ __html: el.code }}
            className="pt-0_5"
          />
        ))}
      </Spin>
    </div>
  );
};

export default SiteSponsors;
